import { setApplication, useAppDispatch } from "../../store";

import { submitApplication } from "../../../../Services/portalService.jsx";
import { Application } from "../../../../MPP-Common-SPA/utils/generator/applicationModels";
import { FamilyMember } from "../../../../MPP-Common-SPA/utils/generator/sectionModels";
import { current } from "@reduxjs/toolkit";

export const useGenerationFormSubmit = (form: any, application: any) => {
  const dispatch = useAppDispatch();

  const handleSubmit = async (formInstance?: any) => {
    // Use the passed form instance or fall back to the original form parameter
    const currentForm = formInstance || form;

    if (!currentForm) {
      console.error("No form instance available for submission");
      return;
    }

    try {
      const updatedApplication = new Application({
        applicationTypeId: currentForm.values.applicationTypeId,
        applicationType: currentForm.values.applicationType,
        firstName: currentForm.values.PersonalInformation.givenName,
        middleName: currentForm.values.PersonalInformation.middleName,
        lastName: currentForm.values.PersonalInformation.surname,
        fullName: currentForm.values.PersonalInformation.fullName,
        gender: currentForm.values.PersonalInformation.gender,
        email: currentForm.values.PersonalInformation.email,
        streetAddressLine1:
          currentForm.values.PersonalInformation.streetAddressLine1,
        streetAddressLine2:
          currentForm.values.PersonalInformation.streetAddressLine2,
        locality: currentForm.values.PersonalInformation.locality,
        province: currentForm.values.PersonalInformation.province,
        country: currentForm.values.PersonalInformation.country,
        postalCode: currentForm.values.PersonalInformation.postalCode,
        verificationStatus: currentForm.values.verificationStatus,
        phone: currentForm.values.PersonalInformation.phone,
        dOB: currentForm.values.PersonalInformation.dob.toISOString(),
        mobile: currentForm.values.PersonalInformation.mobile,
        applicationData: {
          ...application?.applicationData!,
          applicationType: currentForm.values.applicationType,
          applicationData: {
            ...application?.applicationData?.applicationData!,
            stepData: {
              ...application?.applicationData?.applicationData?.stepData!,
              PersonalInformation: {
                ignoreUserData: true,
                ...currentForm.values.PersonalInformation,
              },
              EvacuationLocation: {
                ...currentForm.values.EvacuationLocation,
              },
              TemporaryContactInformation:
                currentForm.values.TemporaryContactInformation
                  .returnedToHome === "Y"
                  ? {
                      returnedToHome:
                        currentForm.values.TemporaryContactInformation
                          .returnedToHome,
                      usePersonalNumber: false,
                      tempPhoneNumber: "",
                    }
                  : {
                      ...currentForm.values.TemporaryContactInformation,
                    },
              // If not indigenous, set blank values
              FirstNationStatus: Object.assign(
                {
                  isIndigenous:
                    currentForm.values.FirstNationStatus.isIndigenous,
                  band: "",
                  family: "",
                  position: "",
                  FNIHB: "",
                  livesOnReserve: "N",
                },
                currentForm.values.FirstNationStatus.isIndigenous === "Y"
                  ? currentForm.values.FirstNationStatus
                  : {}
              ),
              // Also does indigenous check
              FamilyMembers: {
                ...currentForm.values.FamilyMembers,
                familyMembers:
                  currentForm.values.FamilyMembers.familyMembers.map(
                    (familyMember: FamilyMember) =>
                      !familyMember.isIndigenous
                        ? {
                            ...familyMember,
                            dob: familyMember.dob.toISOString(),
                            isIndigenous: familyMember.isIndigenous,
                            band: "",
                            family: "",
                            position: "",
                            FNIHB: "",
                            livesOnReserve: "",
                          }
                        : {
                            ...familyMember,
                            dob: familyMember.dob.toISOString(),
                          }
                  ),
              },
              PaymentInformation:
                currentForm.values.verificationStatus !== 1
                  ? {
                      ...currentForm.values.PaymentInformation,
                      ...(currentForm.values.PaymentInformation
                        .receivePayment === "e-transfer"
                        ? {
                            // If email, blank mobile and bank
                            ...(currentForm.values.PaymentInformation
                              .receiveETransfer === "email"
                              ? {
                                  usePersonalNumber: false,
                                  mobile: "",
                                  confirmMobile: "",
                                  bankName: "",
                                  institutionNumber: "",
                                  transitNumber: "",
                                  bankAccount: "",
                                  confirmBankAccount: "",
                                }
                              : currentForm.values.PaymentInformation
                                  .receiveETransfer === "mobile"
                              ? {
                                  // If mobile, blank bank
                                  institutionNumber: "",
                                  transitNumber: "",
                                  bankAccount: "",
                                  confirmBankAccount: "",
                                  bankName: "",
                                }
                              : currentForm.values.PaymentInformation
                                  .receiveETransfer === "bankAccount"
                              ? {
                                  // If bank account, blank mobile
                                  usePersonalNumber: false,
                                  mobile: "",
                                  confirmMobile: "",
                                }
                              : {}),
                          }
                        : {
                            // If in person, blank all e-transfer info
                            usePersonalNumber: false,
                            usePersonalEmail: false,
                            mobile: "",
                            confirmMobile: "",
                            email: "",
                            confirmEmail: "",
                            institutionNumber: "",
                            transitNumber: "",
                            bankAccount: "",
                            confirmBankAccount: "",
                            bankName: "",
                          }),
                    }
                  : {},
            },
          },
        },
      });

      const applicationSubmission = await submitApplication({
        applicationId: updatedApplication.id || null,
        applicationTypeId: updatedApplication.applicationTypeId || "",
        application: JSON.stringify(updatedApplication.applicationData),
      });

      const returnedApplicationData = applicationSubmission.data;
      const { applicationData: _, ...cleanReturnedData } =
        returnedApplicationData;

      const returnedApplication = new Application({
        ...cleanReturnedData,
        applicationData: JSON.parse(
          returnedApplicationData.applicationDataJson
        ),
      });

      // This allows the generator to show what was submitted.
      dispatch(setApplication(returnedApplication));
    } catch (error) {
      console.error("Submission error:", error);
    }
  };

  return { handleSubmit };
};
